<template lang="pug">
.partner
  .partner__logo
    img(
      :src="partner.img"
      :alt="partner.company")

  .partner__info
    //-
    //- Partner Employees
    //-
    template(
      v-for="employee in partner.employees"
      :key="employee.name")
      .partner__employee
        .partner__name {{ employee.name }}
        .partner__email.email--break {{ employee.email }}
        .partner__city ({{ employee.rol[locale] }}, {{ employee.city[locale] }})
        .partner__position(
          v-for="(department, key) in employee.department"
          :key="key")
          | {{ department[locale] }}

        NuxtLink.partner__profile(
          v-if="employee.profile"
          :to="employee.profile[locale]"
          target="_blank"
          external) {{ t('partners.profile') }}

    //-
    //- Partner Description
    //-
    template(v-if="partner.description")
      // eslint-disable-next-line vue/no-v-html
      .partner__description(v-html="partner.description[locale]")
</template>

<script setup lang="ts">
  import type { PartnerEntry } from '../types'

  export interface PartnerCardProps {
    /** Partner rendered by the card. */
    partner: PartnerEntry
  }

  //
  // Props and events
  //
  defineProps<PartnerCardProps>()

  //
  // Composables
  //
  const { t, locale } = useI18n()
</script>

<style lang="scss" scoped>
  .partner {
    display: flex;
    align-items: center;
    column-gap: simple();

    background-color: $color-background;
    border-radius: $border-radius-big;
    padding: double() simple();
  }

  .partner__logo {
    width: 110px;
    min-width: 110px;
  }

  .partner__info {
    padding-left: simple();
    border-left: 1px solid color(gray7);
    color: color(gray4);
    font-size: font-size(small1);
    display: flex;
    flex-direction: column;
    row-gap: simple();
  }

  .partner__name {
    font-size: font-size(base);
    color: color(gray1);
    font-weight: 600;
  }

  .partner__email {
    margin-bottom: half();
  }

  .partner__position {
    font-style: italic;

    &:last-of-type {
      margin-bottom: half();
    }
  }

  .partner__description {
    :deep(p) {
      font-size: font-size(base);

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  @include media(lap) {
    .partner {
      flex-direction: column;
    }

    .partner__logo {
      margin-bottom: simple();
    }

    .partner__info {
      border-left: none;
      padding-left: 0;
      text-align: center;
    }
  }

  @include media(palm) {
    .partner {
      padding: simple() half();
    }
  }
</style>
